"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.magicLink = void 0;

const magicLink = client => {
  return {
    type: 'magicLink',
    client,
    login: async ({
      email,
      showUI
    }) => await client.auth.loginWithMagicLink({
      email,
      showUI
    }),
    logout: async () => {
      await client.user.logout();
    },
    signup: async ({
      email,
      showUI
    }) => await client.auth.loginWithMagicLink({
      email,
      showUI
    }),
    getToken: async () => await client.user.getIdToken(),
    getUserMetadata: async () => (await client.user.isLoggedIn()) ? await client.user.getMetadata() : null
  };
};

exports.magicLink = magicLink;